<template>
  <div class="myusers f-s-s f-d-c w-100 p-5">
    <div class="header f-c-b w-100 mb-3">
      <div class="tableTitle">گروههای کاربری</div>
      <div class="f-c-e searchBox">
        <div class="search f-c-c">
          <input
            v-if="isSearchActive"
            :class="[isSearchActive ? 'searchInputActive' : '']"
            @keyup="searchFunc"
            type="text"
            placeholder="جستجو"
          />
          <b-img
            :class="[isSearchActive ? 'imgActive' : '']"
            :src="require(`@/assets/images/gap/search-icon.svg`)"
            @click="searchIconFunc()"
          ></b-img>
        </div>
        <div
        v-if="user.permissions.add_user_group"
          @click.prevent="addGroupFunc()"
          class="addUser f-c-c"
        >
          <span class="plus ml-2">+</span>
          <div class="text f-c-c">افزودن گروه</div>
        </div>
      </div>
      <!-- <div class="search f-c-c">
        <b-img :src="require(`@/assets/images/gap/search-icon.svg`)"></b-img>
        <input v-model="searchGroup" type="text" placeholder="جستجو" />
      </div>
      <div v-if="user.permissions.add_user_group" class="addUser f-c-c" @click="addGroupFunc()">
        <span class="plus ml-2">+</span>
        <div class="text f-c-c">افزودن گروه</div>
      </div> -->
    </div>
    <div class="userTable groupTable f-c-c f-d-c w-100">
      <div class="header f-c-s w-100">
        <div class="headerItem f-c-s"></div>
        <div class="headerItem f-c-s">عنوان</div>
        <div class="headerItem f-c-s">تعداد کاربران</div>
        <div class="headerItem f-c-c">عملیات</div>
      </div>
      <div v-if="itemsForList.length" class="tableContent f-c-c f-d-c w-100">
        <div
          v-for="(v, i) in itemsForList"
          :key="i"
          class="tableRow f-c-s w-100"
        >
          <div class="tableItem f-c-c">{{ v.row }}</div>
          <div class="tableItem f-c-s">{{ v.title }}</div>
          <div class="tableItem f-c-s">{{ v.count }}</div>
          <div class="tableItem f-c-sa">
            <div v-if="user.permissions.edit_user_group" class="editBtn f-c-c" @click.prevent="editGroupFunc(v)">
              ویرایش
            </div>
            <div v-if="user.permissions.delete_user_group"
              class="deleteBtn f-c-c"
              @click.prevent="deleteGroupFunc(v)"
            >
              حذف
            </div>
            <!-- <b-img v-if="user.permissions.edit_user_group"
              @click.prevent="editGroupFunc(v)"
              class="ml-2"
              :src="require(`@/assets/images/gap/edit-icon.svg`)"
            ></b-img>
            <b-img v-if="user.permissions.delete_user_group"
              @click.prevent="deleteGroupFunc(v)"
              :src="require(`@/assets/images/gap/delete-icon.svg`)"
            ></b-img> -->
          </div>
        </div>
      </div>
      <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
        گروهی وجود ندارد.
      </div>
      <div class="paginationSection f-c-c w-100">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
        <div v-if="mobileGroups.length" class="mobileUserTable f-c-s f-d-c w-100">
      <div
        v-for="(v, i) in mobileGroups"
        :key="i"
        class="tableItem f-c-s f-d-c w-100 mb-3"
      >
        <div class="up f-c-b w-100 mb-3">
          <div class="right f-s-s f-d-c">
            <div class="labelItem f-c-c mb-2">نام :</div>
            <div class="labelItem f-c-c">تعداد کاربران :</div>
          </div>
          <div class="left f-e-e f-d-c">
            <div class="answerItem f-c-e mb-2">
              {{ v.title }}
            </div>
            <div class="answerItem f-c-e">
              {{ v.count}}
            </div>
          </div>
        </div>
        <div class="down f-c-b w-100">
          <div v-if="user.permissions.edit_user_group" class="edit f-c-c" @click.prevent="editGroupFunc(v)">
            <b-img
              :src="require(`@/assets/images/mobile/edit-pen.svg`)"
            ></b-img>
          </div>
          <div v-if="user.permissions.delete_user_group" class="delete f-c-c" @click.prevent="deleteGroupFunc(v)">
            <b-img
              :src="require(`@/assets/images/mobile/delete-x.svg`)"
            ></b-img>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100"
    >
      گروهی وجود ندارد.
    </div>
    <b-modal
      id="edit-modal"
      title="افزودن گروه جدید"
      button-size="sm"
      :hide-footer="footer"
      ref="addGroup-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="row f-c-c w-100 mb-5 mt-3">
          <div class="label f-c-s">عنوان</div>
          <input v-model="addGroup.name" type="text" />
        </div>
        <div class="btnSec w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c" @click="saveGroupFunc()">ذخیره</div>
        </div>
      </template>
    </b-modal>
    <DeleteConfirm v-if="isDelete" message="از حذف این گروه مطمئن هستید ؟" />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteConfirm from "@/components/DelConfirmModal";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "UserGroups",
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      footer: true,
      editGroup: {},
      deleteGroup: {},
      isDelete: false,
      isSearchActive:false,
      iswatie: false,
      addGroup: {
        name: "",
      },
      allGroup: [],
      groups: [],
      mobileGroups: [],
    };
  },
  created() {
    this.getAllUsersGroupFunction({
      user_id: this.user.user_id,
    });
    EventBus.$on("deleteItem", (status) => {
      if (status && this.isDelete) {
        this.deleteUserGroupFunction({
          user_id: this.user.user_id,
          user_group_id: this.deleteGroup.id,
        });
        this.isDelete = false;
      } else {
        this.isDelete = false;
      }
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allUserGroup: (state) => state.gap.allUserGroup,
      addNewGroupStatus: (state) => state.gap.addNewGroupStatus,
      deleteUserGroupStatus: (state) => state.gap.deleteUserGroupStatus,
    }),
    rows() {
      return this.groups.length;
    },
    itemsForList() {
      return this.groups.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },
  components: {
    DeleteConfirm,
  },
  methods: {
    ...mapActions("gap", [
      "getAllUsersGroupFunction",
      "setGroupEditedFunction",
      "addNewGroupFunction",
      "deleteUserGroupFunction",
    ]),
    searchFunc(v){
      let n = v.target.value
      let searchArray = this.allUserGroup.user_groups.filter((ticket) => {
        return (
          ticket.title.toLowerCase().includes(n) ||
          ticket.count.toLowerCase().includes(n)
        );
      });
      this.groups = searchArray;
      this.mobileGroups = searchArray;
    },
    searchIconFunc() {
      this.isSearchActive = !this.isSearchActive;
      setTimeout(() => {
        if (this.isSearchActive) {
          document.querySelector(".searchInputActive").focus();
        }
      }, 200);
    },
    editGroupFunc(v) {
      this.setGroupEditedFunction(v);
      this.$router.push({ name: "userGroupEdit" });
    },
    deleteGroupFunc(v) {
      this.deleteGroup = v;
      this.isDelete = true;
    },
    addGroupFunc() {
      this.addGroup.name = "";
      this.$refs["addGroup-modal"].show();
    },
    saveGroupFunc() {
      if (this.addGroup.name.trim()) {
        this.addNewGroupFunction({
          user_id: this.user.user_id,
          title: this.addGroup.name,
        });
        this.$refs["addGroup-modal"].hide();
      } else {
        this.$bvToast.toast("وارد کردن عنوان الزامی است.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
  },
  watch: {
    allUserGroup(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.groups = n.user_groups;
          this.mobileGroups = n.user_groups;
        } else {
          this.iswatie = true;
        }
      }
    },
    deleteUserGroupStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.getAllUsersGroupFunction({
            user_id: this.user.user_id,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    addNewGroupStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.getAllUsersGroupFunction({
            user_id: this.user.user_id,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {
    if (Object.keys(this.allUserGroup).length) {
      if (this.allUserGroup.code == 100) {
        this.groups = this.allUserGroup.user_groups;
        this.mobileGroups = this.allUserGroup.user_groups;
      } else {
        this.iswatie = true;
      }
    }
  },
};
</script>